// import { useEffect, useRef, useState, useCallback } from "react";
// import { getFuturesContractSize } from "../shared/getContractSize";

// // ========== KuCoin Futures WS (tickerV2 + Level50 + 24h snapshot + funding via WS + REST)
// //  - token:  POST https://api-futures.kucoin.com/api/v1/bullet-public (через ваш прокси)
// //  - ws:     wss://ws-api-futures.kucoin.com?token=...&connectId=...
// //  - topics:
// //      /contractMarket/tickerV2:{SYM}
// //      /contractMarket/level2Depth50:{SYM}
// //      /contractMarket/snapshot:{SYM}       (24h turnover/lastPrice)
// //      /contract/announcement:{SYM}         (funding begin/end)
// //      /contract/announcement               (иногда общий)
// //  SYM: ETHUSDTM / BTCUSDTM

// export const useKucoinFutures = (symbol) => {
//   const [isConnected, setIsConnected] = useState(false);
//   const [error, setError]             = useState(null);
//   const [tickerData, setTickerData]   = useState(null); // { lastPrice, volume24, bid, ask }
//   const [orderBook, setOrderBook]     = useState({ asks: [], bids: [] });
//   const [fundingRate, setFundingRate] = useState(0);

//   const wsRef = useRef(null);
//   const pingTimerRef = useRef(null);
//   const animationFrameRef = useRef(null);

//   const orderBookRef = useRef({ asks: [], bids: [] });
//   const readyToSubRef = useRef(false);
//   const contractSizeRef = useRef(1);

//   const log = (...a) => console.log("🟪 [KUCOIN FUTURES]", ...a);
//   const PROXY_ORIGIN = process.env.REACT_APP_BACKEND_URL;
//   const viaProxy = (absUrl) => `${PROXY_ORIGIN}/proxy/${encodeURI(absUrl)}`;
//   const TOKEN_URL_FUT = `${PROXY_ORIGIN}/https://api-futures.kucoin.com/api/v1/bullet-public`;

//   // ---------- helpers ----------
//   const toPairs = (rows) =>
//     Array.isArray(rows) ? rows.map(([p, q]) => [String(p), String(q)]) : [];

//   const scaleBook = useCallback((ob) => {
//     const k = contractSizeRef.current || 1;
//     const mul = (arr) => arr.map(([p,q]) => [p, String(Number(q) * k)]);
//     return { asks: mul(ob.asks || []), bids: mul(ob.bids || []) };
//   }, []);

//   const applyFullBook = useCallback((asks, bids) => {
//     orderBookRef.current = {
//       asks: asks.slice(0, 20).sort((a,b)=>+a[0]-+b[0]),
//       bids: bids.slice(0, 20).sort((a,b)=>+b[0]-+a[0]),
//     };
//     if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
//     animationFrameRef.current = requestAnimationFrame(() => {
//       setOrderBook(scaleBook(orderBookRef.current)); // 👈 масштабируем
//     });
//   }, [scaleBook]);

//   const formatFutSymbol = useCallback((sym) => {
//     let s = sym.replace(/[_-]/g, "");
//     if (!/M$/.test(s)) s = `${s}M`;
//     return s;
//   }, []);

//   const buildTopics = useCallback((inst) => ({
//     tickerV2:    `/contractMarket/tickerV2:${inst}`,
//     level50:     `/contractMarket/level2Depth50:${inst}`,
//     snapshot24h: `/contractMarket/snapshot:${inst}`,
//     fundingInst: `/contract/announcement:${inst}`,
//     fundingAll:  `/contract/announcement`,
//   }), []);

//   const subscribeAll = useCallback((ws, inst) => {
//     const { tickerV2, level50, snapshot24h, fundingInst, fundingAll } = buildTopics(inst);
//     const id = Date.now();
//     const subs = [
//       { id,       type: "subscribe", topic: tickerV2,    response: true },
//       { id: id+1, type: "subscribe", topic: level50,     response: true },
//       { id: id+2, type: "subscribe", topic: snapshot24h, response: true },
//       { id: id+3, type: "subscribe", topic: fundingInst, response: true },
//       { id: id+4, type: "subscribe", topic: fundingAll,  response: true },
//     ];
//     subs.forEach(m => ws.send(JSON.stringify(m)));
//     log("→ SUB", subs);
//   }, [buildTopics]);

//   const unsubscribeAll = useCallback((ws, inst) => {
//     try {
//       const { tickerV2, level50, snapshot24h, fundingInst, fundingAll } = buildTopics(inst);
//       const id = Date.now();
//       const us = [
//         { id,       type: "unsubscribe", topic: tickerV2,    response: true },
//         { id: id+1, type: "unsubscribe", topic: level50,     response: true },
//         { id: id+2, type: "unsubscribe", topic: snapshot24h, response: true },
//         { id: id+3, type: "unsubscribe", topic: fundingInst, response: true },
//         { id: id+4, type: "unsubscribe", topic: fundingAll,  response: true },
//       ];
//       us.forEach(m => ws?.send(JSON.stringify(m)));
//       log("→ UNSUB", us);
//     } catch {}
//   }, [buildTopics]);

//   const fetchWsConfig = useCallback(async () => {
//     const url = viaProxy(TOKEN_URL_FUT);
//     try {
//       const r = await fetch(url, { method: "POST", headers: { 'ngrok-skip-browser-warning': '1' } });
//       if (!r.ok) throw new Error(`HTTP ${r.status}`);
//       return await r.json();
//     } catch {
//       const r2 = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
//       if (!r2.ok) throw new Error(`HTTP ${r2.status}`);
//       return await r2.json();
//     }
//   }, []);

//   // Текущий фандинг через REST (дополнительно к WS-ивентам)
//   const fetchCurrentFunding = useCallback(async (inst) => {
//     try {
//       const url = viaProxy(`https://api-futures.kucoin.com/api/v1/funding-rate/${inst}/current`);
//       const r = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
//       if (!r.ok) throw new Error(`HTTP ${r.status}`);
//       const json = await r.json();
//       if (json?.data?.value != null) {
//         const v = Number(json.data.value);
//         if (!Number.isNaN(v)) setFundingRate(v);
//       }
//     } catch (e) {
//       log("❌ FUNDING REST ERROR:", e);
//     }
//   }, []);

//   // ---------- WS message handler ----------
//   const handleMessage = useCallback((event, inst) => {
//     try {
//       if (typeof event.data !== "string") return;
//       const msg = JSON.parse(event.data);

//       if (msg.type === "welcome") { readyToSubRef.current = true; return; }
//       if (msg.type === "pong" || msg.type === "ack") return;

//       // tickerV2 (bid/ask; last≈mid, точный last даёт snapshot)
//       if (msg.topic?.startsWith("/contractMarket/tickerV2:")) {
//         const d = msg.data || {};
//         const bid = d.bestBidPrice, ask = d.bestAskPrice;
//         let last = undefined;
//         const nb = Number(bid), na = Number(ask);
//         if (!Number.isNaN(nb) && !Number.isNaN(na)) last = ((nb + na) / 2).toFixed(6);

//         setTickerData(prev => ({
//           ...(prev || {}),
//           symbol,
//           lastPrice: last ?? prev?.lastPrice,
//           bid: bid ?? prev?.bid,
//           ask: ask ?? prev?.ask,
//         }));
//         return;
//       }

//       // Level50 стакан
//       if (msg.topic?.startsWith("/contractMarket/level2Depth50:")) {
//         const d = msg.data || {};
//         const asks = Array.isArray(d.asks) ? d.asks : [];
//         const bids = Array.isArray(d.bids) ? d.bids : [];
//         const toPairs = (rows) => rows.map(([p, q]) => [String(p), String(q)]);
//         applyFullBook(toPairs(asks), toPairs(bids)); // масштабирование внутри applyFullBook
//         return;
//       }

//       // Snapshot 24h (turnover=quote volume USDT, lastPrice)
//       if (msg.topic?.startsWith("/contractMarket/snapshot:")) {
//         const d = msg.data || {};
//         const turnover = d.turnover; // quote volume (USDT)
//         const last = d.lastPrice;
//         setTickerData(prev => ({
//           ...(prev || {}),
//           symbol,
//           lastPrice: (last != null) ? String(last) : (prev?.lastPrice ?? ""),
//           volume24: (turnover != null) ? String(turnover) : (prev?.volume24 ?? ""),
//         }));
//         return;
//       }

//       // Funding announcements (begin/end)
//       if (msg.topic === "/contract/announcement" || msg.topic?.startsWith("/contract/announcement:")) {
//         const d = msg.data || {};
//         if (d.symbol && d.symbol !== inst) return;

//         const raw = d.fundingRate;
//         const v = Number(raw);
//         if (!Number.isNaN(v)) {
//           setFundingRate(v);
//           log(`💰 FUNDING evt:`, { symbol: d.symbol, rate: v, fundingTime: d.fundingTime, ts: d.timestamp });
//         }
//         return;
//       }
//     } catch (e) {
//       log("❌ parse error:", e);
//     }
//   }, [applyFullBook, symbol]);

//   // ---------- effect ----------
//   useEffect(() => {
//     if (!symbol) return;

//     const inst = formatFutSymbol(symbol);

//     setIsConnected(false);
//     setError(null);
//     setTickerData(null);
//     setOrderBook({ asks: [], bids: [] });
//     setFundingRate(0);
//     orderBookRef.current = { asks: [], bids: [] };
//     readyToSubRef.current = false;

//     let ws;
//     let pingIntervalMs = 20000;

//     (async () => {
//       try {
//         // получаем multiplier ДО WS
//         contractSizeRef.current = await getFuturesContractSize("kucoin", inst);

//         const conf = await fetchWsConfig();
//         const data = conf?.data;
//         const server = data?.instanceServers?.[0];
//         if (!data?.token || !server?.endpoint) throw new Error("No token/endpoint");

//         pingIntervalMs = Number(server.pingInterval || 20000);
//         const connectId = String(Date.now());
//         const wsUrl = `${server.endpoint}?token=${encodeURIComponent(data.token)}&connectId=${connectId}`;

//         ws = new WebSocket(wsUrl);
//         wsRef.current = ws;

//         ws.onopen = () => {
//           log("🔗 open:", inst);
//           setIsConnected(true);

//           // сразу подтянем текущий фандинг
//           fetchCurrentFunding(inst);

//           // heartbeat
//           pingTimerRef.current = setInterval(() => {
//             try { ws.send(JSON.stringify({ id: Date.now(), type: "ping" })); } catch {}
//           }, Math.max(5000, pingIntervalMs || 20000) - 1000);
//         };

//         ws.onmessage = (evt) => {
//           if (!readyToSubRef.current) {
//             try {
//               const probe = JSON.parse(evt.data);
//               if (probe?.type === "welcome") {
//                 readyToSubRef.current = true;
//                 // подписываемся только после welcome
//                 subscribeAll(ws, inst);
//               }
//             } catch {}
//           }
//           handleMessage(evt, inst);
//         };

//         ws.onerror = (e) => {
//           log("❌ ws error:", e);
//           setError(e?.message || "WS error");
//           setIsConnected(false);
//         };
//         ws.onclose = () => {
//           log("🔌 close");
//           setIsConnected(false);
//         };
//       } catch (e) {
//         setError(e.message);
//         log("❌ token/ws init:", e);
//       }
//     })();

//     return () => {
//       try {
//         if (ws && ws.readyState === WebSocket.OPEN) {
//           unsubscribeAll(ws, inst);
//           ws.close();
//         }
//       } catch {}
//       if (pingTimerRef.current) { clearInterval(pingTimerRef.current); pingTimerRef.current = null; }
//       if (animationFrameRef.current) { cancelAnimationFrame(animationFrameRef.current); animationFrameRef.current = null; }
//       wsRef.current = null;
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     symbol,               // меняем только при смене символа
//     formatFutSymbol,      // мемоизирован
//     fetchWsConfig,        // мемоизирован
//     subscribeAll,         // мемоизирован
//     unsubscribeAll,       // мемоизирован
//     handleMessage,        // мемоизирован
//     fetchCurrentFunding,  // мемоизирован
//   ]);

//   return { isConnected, error, orderBook, tickerData, fundingRate };
// };
/* eslint-disable max-len */
// src/hooks/orderbooks/useKucoinFutures.js
import { useEffect, useRef, useState, useCallback } from "react";
import { getFuturesContractSize } from "../shared/getContractSize";

const PROXY_ORIGIN = process.env.REACT_APP_BACKEND_URL;
const log = (...a) => console.log("🟪 [KUCOIN FUTURES]", ...a);

const viaProxy = (absUrl) => `${PROXY_ORIGIN}/proxy/${encodeURI(absUrl)}`;
const TOKEN_URL_FUT = "https://api-futures.kucoin.com/api/v1/bullet-public";

// ---------- helpers ----------
const toPairs = (rows) =>
  Array.isArray(rows) ? rows.map(([p, q]) => [String(p), String(q)]) : [];

const normalizeKucoinFutEndpoint = (endpoint) => {
  try {
    const u = new URL(endpoint);
    if (!u.hostname.endsWith("kucoin.com")) {
      u.hostname = "ws-api-futures.kucoin.com";
      u.protocol = "wss:";
    }
    return u.toString();
  } catch {
    return "wss://ws-api-futures.kucoin.com";
  }
};

const formatFutSymbol = (sym) => {
  let s = String(sym).replace(/[_-]/g, "");
  if (!/M$/.test(s)) s = `${s}M`; // ETHUSDT -> ETHUSDTM
  return s.toUpperCase();
};

const buildTopics = (inst) => ({
  tickerV2:    `/contractMarket/tickerV2:${inst}`,
  level50:     `/contractMarket/level2Depth50:${inst}`,
  snapshot24h: `/contractMarket/snapshot:${inst}`,     // содержит lastPrice/turnover(quote vol)
  fundingInst: `/contract/announcement:${inst}`,
  fundingAll:  `/contract/announcement`,
});

// ---------- hook ----------
/**
 * KuCoin Futures (USDT-M) — WS:
 *  - tickerV2, level2Depth50, snapshot (24h), funding announcements
 * Возвращает: { isConnected, error, orderBook, tickerData, fundingRate }
 */
export const useKucoinFutures = (symbol) => {
  const [isConnected, setIsConnected]   = useState(false);
  const [error, setError]               = useState(null);
  const [tickerData, setTickerData]     = useState(null);   // { lastPrice, volume24, bid, ask }
  const [orderBook, setOrderBook]       = useState({ asks: [], bids: [] });
  const [fundingRate, setFundingRate]   = useState(0);

  const wsRef = useRef(null);
  const pingTimerRef = useRef(null);
  const animationFrameRef = useRef(null);
  const readyToSubRef = useRef(false);
  const contractSizeRef = useRef(1);

  const scaleBook = useCallback((ob) => {
    const k = contractSizeRef.current || 1;
    const mul = (arr) => arr.map(([p, q]) => [p, String(Number(q) * k)]);
    return { asks: mul(ob.asks || []), bids: mul(ob.bids || []) };
  }, []);

  const applyFullBook = useCallback((asks, bids) => {
    const ob = {
      asks: asks.slice(0, 20).sort((a,b)=>+a[0]-+b[0]),
      bids: bids.slice(0, 20).sort((a,b)=>+b[0]-+a[0]),
    };
    if (animationFrameRef.current) cancelAnimationFrame(animationFrameRef.current);
    animationFrameRef.current = requestAnimationFrame(() => {
      setOrderBook(scaleBook(ob));
    });
  }, [scaleBook]);

  const subscribeAll = useCallback((ws, inst) => {
    const { tickerV2, level50, snapshot24h, fundingInst, fundingAll } = buildTopics(inst);
    const id = Date.now();
    const subs = [
      { id,       type: "subscribe", topic: tickerV2,    response: true },
      { id: id+1, type: "subscribe", topic: level50,     response: true },
      { id: id+2, type: "subscribe", topic: snapshot24h, response: true },
      { id: id+3, type: "subscribe", topic: fundingInst, response: true },
      { id: id+4, type: "subscribe", topic: fundingAll,  response: true },
    ];
    subs.forEach(m => ws.send(JSON.stringify(m)));
    log("→ SUB", subs);
  }, []);

  const unsubscribeAll = useCallback((ws, inst) => {
    try {
      const { tickerV2, level50, snapshot24h, fundingInst, fundingAll } = buildTopics(inst);
      const id = Date.now();
      const us = [
        { id,       type: "unsubscribe", topic: tickerV2,    response: true },
        { id: id+1, type: "unsubscribe", topic: level50,     response: true },
        { id: id+2, type: "unsubscribe", topic: snapshot24h, response: true },
        { id: id+3, type: "unsubscribe", topic: fundingInst, response: true },
        { id: id+4, type: "unsubscribe", topic: fundingAll,  response: true },
      ];
      us.forEach(m => ws?.send(JSON.stringify(m)));
      log("→ UNSUB", us);
    } catch {}
  }, []);

  const fetchWsConfig = useCallback(async () => {
    const url = viaProxy(TOKEN_URL_FUT);
    // пробуем POST (как в доке)
    try {
      const r = await fetch(url, { method: "POST", headers: { 'ngrok-skip-browser-warning': '1' } });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return await r.json();
    } catch {
      // если прокси не пускает POST — fallback на GET
      const r2 = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
      if (!r2.ok) throw new Error(`HTTP ${r2.status}`);
      return await r2.json();
    }
  }, []);

  // Доп. REST на текущий фандинг (не обязателен, но полезен для первичной отрисовки)
  const fetchCurrentFunding = useCallback(async (inst) => {
    try {
      const url = viaProxy(`https://api-futures.kucoin.com/api/v1/funding-rate/${inst}/current`);
      const r = await fetch(url, { headers: { 'ngrok-skip-browser-warning': '1' } });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const json = await r.json();
      if (json?.data?.value != null) {
        const v = Number(json.data.value);
        if (!Number.isNaN(v)) setFundingRate(v);
      }
    } catch (e) {
      log("❌ FUNDING REST ERROR:", e?.message || String(e));
    }
  }, []);

  const handleMessage = useCallback((event, inst) => {
    try {
      if (typeof event.data !== "string") return;
      const msg = JSON.parse(event.data);

      if (msg.type === "welcome") { readyToSubRef.current = true; return; }
      if (msg.type === "pong" || msg.type === "ack") return;

      // ---- tickerV2: bid/ask; last ≈ mid (точный last придёт из snapshot)
      if (msg.topic?.startsWith("/contractMarket/tickerV2:")) {
        const d = msg.data || {};
        const bid = d.bestBidPrice, ask = d.bestAskPrice;
        let last = undefined;
        const nb = Number(bid), na = Number(ask);
        if (!Number.isNaN(nb) && !Number.isNaN(na)) last = ((nb + na) / 2).toFixed(6);

        setTickerData(prev => ({
          ...(prev || {}),
          symbol: inst,
          lastPrice: last ?? prev?.lastPrice,
          bid: bid ?? prev?.bid,
          ask: ask ?? prev?.ask,
        }));
        return;
      }

      // ---- Level2Depth50
      if (msg.topic?.startsWith("/contractMarket/level2Depth50:")) {
        const d = msg.data || {};
        const asks = toPairs(d.asks);
        const bids = toPairs(d.bids);
        applyFullBook(asks, bids); // масштабирование внутри applyFullBook
        return;
      }

      // ---- Snapshot 24h (turnover = quote volume USDT), lastPrice
      if (msg.topic?.startsWith("/contractMarket/snapshot:")) {
        const d = msg.data || {};
        const turnover = d.turnover;
        const last = d.lastPrice;
        setTickerData(prev => ({
          ...(prev || {}),
          symbol: inst,
          lastPrice: (last != null) ? String(last) : (prev?.lastPrice ?? ""),
          volume24: (turnover != null) ? String(turnover) : (prev?.volume24 ?? ""),
        }));
        return;
      }

      // ---- Funding announcements (begin/end)
      if (msg.topic === "/contract/announcement" || msg.topic?.startsWith("/contract/announcement:")) {
        const d = msg.data || {};
        if (d.symbol && d.symbol !== inst) return;

        const raw = d.fundingRate;
        const v = Number(raw);
        if (!Number.isNaN(v)) {
          setFundingRate(v);
          log(`💰 FUNDING evt:`, { symbol: d.symbol, rate: v, fundingTime: d.fundingTime, ts: d.timestamp });
        }
        return;
      }
    } catch (e) {
      log("❌ parse error:", e);
    }
  }, [applyFullBook]);

  useEffect(() => {
    if (!symbol) return;

    const inst = formatFutSymbol(symbol);

    setIsConnected(false);
    setError(null);
    setTickerData(null);
    setOrderBook({ asks: [], bids: [] });
    setFundingRate(0);
    readyToSubRef.current = false;

    let ws;
    let pingIntervalMs = 20000;

    (async () => {
      try {
        // multiplier (масштабируем объёмы)
        contractSizeRef.current = await getFuturesContractSize("kucoin", inst);

        const conf = await fetchWsConfig();
        const data = conf?.data;
        const server = data?.instanceServers?.[0];
        const token  = data?.token;
        if (!server?.endpoint || !token) throw new Error("No token/endpoint");

        const endpoint = normalizeKucoinFutEndpoint(server.endpoint);
        pingIntervalMs = Number(server.pingInterval || 20000);

        // формируем ws url строго через URL API (чтобы не потерять '?')
        const u = new URL(endpoint);
        u.searchParams.set("token", token);
        u.searchParams.set("connectId", String(Date.now()));
        const wsUrl = u.toString();

        ws = new WebSocket(wsUrl);
        wsRef.current = ws;

        ws.onopen = () => {
          log("🔗 open:", inst, wsUrl);
          setIsConnected(true);

          // сразу подтянем текущий фандинг (REST)
          fetchCurrentFunding(inst);

          // heartbeat
          pingTimerRef.current = setInterval(() => {
            try { ws.send(JSON.stringify({ id: Date.now(), type: "ping" })); } catch {}
          }, Math.max(5000, pingIntervalMs - 1000));
        };

        ws.onmessage = (evt) => {
          // Подписываемся только после welcome
          if (!readyToSubRef.current) {
            try {
              const probe = JSON.parse(evt.data);
              if (probe?.type === "welcome") {
                readyToSubRef.current = true;
                subscribeAll(ws, inst);
              }
            } catch {}
          }
          handleMessage(evt, inst);
        };

        ws.onerror = (e) => {
          log("❌ ws error:", e);
          setError(e?.message || "WS error");
          setIsConnected(false);
        };
        ws.onclose = () => {
          log("🔌 close");
          setIsConnected(false);
        };
      } catch (e) {
        setError(e.message);
        log("❌ token/ws init:", e);
      }
    })();

    return () => {
      try {
        if (ws && ws.readyState === WebSocket.OPEN) {
          unsubscribeAll(ws, inst);
          ws.close();
        }
      } catch {}
      if (pingTimerRef.current) { clearInterval(pingTimerRef.current); pingTimerRef.current = null; }
      if (animationFrameRef.current) { cancelAnimationFrame(animationFrameRef.current); animationFrameRef.current = null; }
      wsRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [symbol, fetchWsConfig, subscribeAll, unsubscribeAll, handleMessage, fetchCurrentFunding]);

  return { isConnected, error, orderBook, tickerData, fundingRate };
};
